import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import EscoDataGrid from "../../Controls/EscoGrid/EscoDataGrid";
import { getLeyendaFirmaList } from "../../../Service/leyendasFirma";
import LeyendaFirmaView from "./LeyendaFirmaView";
import { FrmDelLeyendafirmasSoc } from "../../../Service/leyendasFirma";

export default function LeyendaFirmaDataView() {

    const { accessToken } = useContext(AuthContext);

    const [leyendasFirma, setLeyendasFirma] = useState([]);
    const [loading, setLoading] = useState(false);

    const { tokenExpiration, getAccessToken } = useContext(AuthContext);

    const [rowSelectd, setRowSelectd] = useState("Hola");

//region - "description"

    /*DELETE INICIO*/
    const [showDelete, setShowDelete] = useState(false)

    const closeDeleteDialog = () => {
        setShowDelete(false);
    };   

    const ConfirmDelete = () => {            
        delFondoImg(rowSelectd);
        setShowDelete(false);
    }

    const delFondoImg = (row) => {


        var frmDelLeyendasFirmasSocRequest = {
            CodLeyendaFirma: row.CodLeyendaFirma
        }

        const datos = { frmDelLeyendasFirmasSocRequest }

        FrmDelLeyendafirmasSoc(datos, accessToken)
            .then(data => {

                if(data!= undefined && data.Message != undefined && data.Message.includes("Error")){
                   
                    init();
                    return;
                }else{
                    init();
                }  
            }).catch(
                error => { 
                    
                }); 

    }

//endregion

    useEffect(() => {
        init();        
    }, [])

    const init = () => {
        console.log('expiration', new Date(tokenExpiration), new Date(Date.now()))

        getAccessToken()
            .then((token) => {
                setLoading(true);
                getLeyendaFirmaList(token)
                    .then((data) => {
                        setLeyendasFirma(data);
                        setLoading(false)
                    })
                    .catch()
                    .finally(() => setLoading(false))

            })
    } 
 

    const columns = [
        { field: 'DescLeyenda', headerName: 'Leyenda', width: 200 },
        { field: 'DescImagen', headerName: 'Firma', width: 200 },
        { field: 'DescPosicion', headerName: 'Posición', width: 200 },
    ];

    const rows = leyendasFirma

    function getRowId(row) {
        return row.CodLeyendaFirma
    }    

    function setData(data) {
        
        setLeyendasFirma(leyendasFirma.concat({ CodLeyendaFirma: data.CodLeyendaFirma
            ,CodLeyenda: data.CodLeyenda
            ,DescLeyenda: data.DescLeyenda
            ,stream_id: data.stream_id
            ,DescImagen: data.DescImagen 
            ,CodFirmaPosicion: data.CodFirmaPosicion
            ,DescPosicion: data.DescPosicion}))
    }

        return (
            <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Leyendas - Firma </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={true}
                pEditar={true}
                pSetShowDelete={setShowDelete}
                pSetRowSelectd = {setRowSelectd}    
            >
                <LeyendaFirmaView setData={setData} pInit={init}/>
            </EscoDataGrid>

            <Dialog open={showDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Atención"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Desea eliminar el registro?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog}>Cancelar</Button>
                    <Button onClick={ConfirmDelete} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
        );

};